module.exports = __webpack_public_path__ + "static/media/listaZelja.4295f0d5.svg";